import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {MessagesEnum} from "./enums/messages.enum";
import {IframeBitcoinAppMessageInterface} from "./bitcoin-app/interfaces/iframe-bitcoin-app-message.interface";


@Injectable({
  providedIn: 'root'
})
export class IframeMessagesService {
  sendMessage$: BehaviorSubject<IframeBitcoinAppMessageInterface> = new BehaviorSubject({send: 0});
  getMessage$: BehaviorSubject<any> = new BehaviorSubject({send: 0});
  private listenIframeMessageFunction: (event: MessageEvent) => void;
  constructor() {
    this.listenIframeMessageFunction = this.handleListenIframeMessageFunction.bind(this);
  }

  listenIframeMessage() {
    this.getMessage$ = new BehaviorSubject({send: 0});
    window.addEventListener('message', this.listenIframeMessageFunction, false);
  }

  unlistenIframeMessage() {
    window.removeEventListener('message', this.listenIframeMessageFunction, false);
    this.getMessage$.complete();
  }

  handleListenIframeMessageFunction(event: MessageEvent) {
    //console.log(event)
    if (event && event.data) {
      if (this.getMessage$) {
        this.getMessage$.next({
          send: Math.random(),
          data: event.data
        })
      }
    }
  }

  closeFrame() {
    this.sendMessage({
      event: MessagesEnum.closeFrame
    });
  }


  sendMessage(message = {}) {
    parent.postMessage(message, "*");
  }
}
